import { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useImpersonate } from '../../i18n/ImpersonateContext';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const h = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const fmt = n => Number(n || 0).toLocaleString('uz-UZ');

const TABS = ['Umumiy', 'Kompyuterlar', 'Sessiyalar', 'Daromad', 'Snack-bar', 'Sozlamalar'];

// ── Tab: Umumiy ──────────────────────────────────────────────────────────────
function OverviewTab({ lab }) {
  if (!lab) return null;
  const rows = [
    ['Nomi', lab.name],
    ['Egasi', lab.owner_name],
    ['Email', lab.owner_email],
    ['Shahar', lab.city || '—'],
    ['Kompyuterlar', lab.computers_count],
    ['Aktiv sessiyalar', lab.active_sessions],
    ["Bugungi daromad", fmt(lab.revenue_today) + ' so\'m'],
    ["Oylik daromad", fmt(lab.revenue_month) + ' so\'m'],
    ['Obuna holati', lab.sub_status],
    ['Obuna tugash', lab.sub_end ? new Date(lab.sub_end).toLocaleDateString('uz-UZ') : '—'],
    ['Faolmi', lab.is_active ? 'Ha' : 'Yo\'q'],
  ];
  return (
    <div style={{ maxWidth: 600 }}>
      {rows.map(([k, v]) => (
        <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--border)' }}>
          <span style={{ color: 'var(--text3)', fontSize: 13 }}>{k}</span>
          <span style={{ fontWeight: 700, fontSize: 13 }}>{v}</span>
        </div>
      ))}
    </div>
  );
}

// ── Tab: Kompyuterlar ────────────────────────────────────────────────────────
function ComputersTab({ labId }) {
  const [data, setData] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [addNum, setAddNum] = useState('');
  const [addCount, setAddCount] = useState('1');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const reload = () => {
    axios.get(`${API}/super/labs/${labId}/computers`, h())
      .then(r => setData(Array.isArray(r.data) ? r.data : []))
      .catch(() => setData([]));
  };

  useEffect(() => { reload(); }, [labId]); // eslint-disable-line react-hooks/exhaustive-deps

  const addPCs = async () => {
    setErr('');
    const count = parseInt(addCount) || 1;
    if (addNum.trim()) {
      // Bitta raqam qo'shish
      const num = parseInt(addNum);
      if (!num || num < 1) return setErr('Raqam 1 dan katta bo\'lishi kerak');
      setSaving(true);
      try {
        await axios.post(`${API}/super/labs/${labId}/computers`, { number: num }, h());
        setShowAdd(false); setAddNum(''); setAddCount('1');
        reload();
      } catch (e) { setErr(e.response?.data?.error || 'Xatolik'); }
      setSaving(false);
    } else {
      // Ketma-ket N ta qo'shish
      if (count < 1 || count > 100) return setErr('1 dan 100 gacha');
      setSaving(true);
      try {
        const existing = data.map(c => c.number);
        const maxNum = existing.length ? Math.max(...existing) : 0;
        for (let i = 1; i <= count; i++) {
          await axios.post(`${API}/super/labs/${labId}/computers`, { number: maxNum + i }, h());
        }
        setShowAdd(false); setAddNum(''); setAddCount('1');
        reload();
      } catch (e) { setErr(e.response?.data?.error || 'Xatolik'); }
      setSaving(false);
    }
  };

  const deletePc = async (pc) => {
    if (pc.session_id) return alert('Faol sessiya bor — avval sessiyani tugatib o\'chirish mumkin');
    if (!window.confirm(`PC-${String(pc.number).padStart(2,'0')} ni o'chirasizmi?`)) return;
    try {
      await axios.delete(`${API}/super/labs/${labId}/computers/${pc.id}`, h());
      reload();
    } catch (e) { alert(e.response?.data?.error || 'Xatolik'); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 13, color: 'var(--text3)' }}>{data.length} ta kompyuter</div>
        <button onClick={() => setShowAdd(true)} style={{
          background: 'rgba(245,158,11,0.15)', border: '1px solid #f59e0b', color: '#f59e0b',
          padding: '8px 18px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13,
        }}>+ PC Qo'shish</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 10 }}>
        {data.map(pc => (
          <div key={pc.id} style={{
            background: 'var(--bg2)', borderRadius: 12, padding: 14, position: 'relative',
            border: `1px solid ${pc.session_id ? '#10b981' : pc.is_broken ? '#ef4444' : 'var(--border)'}`,
          }}>
            <div style={{ fontWeight: 700, fontSize: 16, fontFamily: 'Orbitron, monospace' }}>
              PC-{String(pc.number).padStart(2, '0')}
            </div>
            {pc.session_id ? (
              <>
                <div style={{ fontSize: 11, color: '#10b981', marginTop: 4 }}>● Faol</div>
                <div style={{ fontSize: 12, marginTop: 4, color: 'var(--text2)' }}>{pc.user_name || 'Mehmon'}</div>
                <div style={{ fontSize: 11, color: 'var(--text3)' }}>
                  {pc.minutes_left != null ? `${pc.minutes_left} daq qoldi` : '—'}
                </div>
              </>
            ) : (
              <div style={{ fontSize: 11, color: pc.is_broken ? '#ef4444' : 'var(--text3)', marginTop: 4 }}>
                {pc.is_broken ? '⚠ Nosoz' : 'Bo\'sh'}
              </div>
            )}
            <button
              onClick={() => deletePc(pc)}
              title="O'chirish"
              style={{
                position: 'absolute', top: 8, right: 8, background: 'transparent',
                border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 14, padding: 2,
                lineHeight: 1,
              }}
            >✕</button>
          </div>
        ))}
        {data.length === 0 && (
          <div style={{ gridColumn: '1/-1', color: 'var(--text3)', textAlign: 'center', padding: 32 }}>
            Kompyuter yo'q. "+ PC Qo'shish" tugmasini bosing.
          </div>
        )}
      </div>

      {showAdd && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
        }}>
          <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16, padding: 32, width: 360 }}>
            <h3 style={{ marginBottom: 20 }}>🖥️ PC Qo'shish</h3>
            {err && <div style={{ color: '#ef4444', fontSize: 13, marginBottom: 12 }}>{err}</div>}
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, color: 'var(--text2)', display: 'block', marginBottom: 6 }}>
                Bitta raqam (bo'sh qoldiring → ketma-ket qo'shish)
              </label>
              <input
                type="number" min="1" value={addNum} onChange={e => setAddNum(e.target.value)}
                placeholder="masalan: 11"
                style={{ width: '100%', background: 'var(--card2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '10px 14px', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
              />
            </div>
            {!addNum && (
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 12, color: 'var(--text2)', display: 'block', marginBottom: 6 }}>
                  Nechtadan qo'shish (mavjud eng kattasidan keyin)
                </label>
                <input
                  type="number" min="1" max="100" value={addCount} onChange={e => setAddCount(e.target.value)}
                  style={{ width: '100%', background: 'var(--card2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '10px 14px', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                />
              </div>
            )}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => { setShowAdd(false); setErr(''); setAddNum(''); setAddCount('1'); }} style={{
                flex: 1, background: 'transparent', border: '1px solid var(--border)',
                color: 'var(--text2)', padding: 10, borderRadius: 8, cursor: 'pointer', fontSize: 13,
              }}>Bekor</button>
              <button onClick={addPCs} disabled={saving} style={{
                flex: 1, background: 'rgba(245,158,11,0.2)', border: '1px solid #f59e0b',
                color: '#f59e0b', padding: 10, borderRadius: 8, cursor: saving ? 'not-allowed' : 'pointer',
                fontSize: 13, fontWeight: 700, opacity: saving ? 0.6 : 1,
              }}>{saving ? 'Qo\'shilmoqda...' : 'Qo\'shish'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Tab: Sessiyalar ──────────────────────────────────────────────────────────
function SessionsTab({ labId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState('today');

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/super/labs/${labId}/sessions`, { ...h(), params: { period, limit: 50 } })
      .then(r => setRows(r.data.sessions))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [labId, period]);

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['today', 'week', 'month'].map(p => (
          <button key={p} onClick={() => setPeriod(p)} style={{
            padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700,
            background: period === p ? 'rgba(245,158,11,0.2)' : 'var(--bg2)',
            border: `1px solid ${period === p ? '#f59e0b' : 'var(--border)'}`,
            color: period === p ? '#f59e0b' : 'var(--text2)',
          }}>{p === 'today' ? 'Bugun' : p === 'week' ? 'Hafta' : 'Oy'}</button>
        ))}
      </div>
      <div style={{ background: 'var(--bg2)', borderRadius: 12, overflow: 'hidden', border: '1px solid var(--border)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              {['Foydalanuvchi', 'Kompyuter', 'Boshlangan', 'Tugagan', 'Davomiyligi', 'Summa'].map(col => (
                <th key={col} style={{ padding: '10px 14px', textAlign: 'left', fontSize: 11, color: 'var(--text3)', fontWeight: 700 }}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', padding: 30, color: 'var(--text3)' }}>Yuklanmoqda...</td></tr>
            ) : rows.map(s => (
              <tr key={s.id} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '10px 14px', fontSize: 13 }}>{s.user_name}</td>
                <td style={{ padding: '10px 14px', fontSize: 13 }}>{s.computer_name}</td>
                <td style={{ padding: '10px 14px', fontSize: 12, color: 'var(--text3)' }}>
                  {new Date(s.started_at).toLocaleString('uz-UZ')}
                </td>
                <td style={{ padding: '10px 14px', fontSize: 12, color: 'var(--text3)' }}>
                  {s.ended_at ? new Date(s.ended_at).toLocaleString('uz-UZ') : <span style={{ color: '#10b981' }}>Faol</span>}
                </td>
                <td style={{ padding: '10px 14px', fontSize: 13 }}>
                  {s.duration_minutes != null ? `${s.duration_minutes} daq` : '—'}
                </td>
                <td style={{ padding: '10px 14px', fontWeight: 700, color: '#f59e0b' }}>
                  {fmt(s.amount)} so'm
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Tab: Daromad ─────────────────────────────────────────────────────────────
function RevenueTab({ labId }) {
  const [data, setData] = useState(null);
  const [period, setPeriod] = useState('month');

  useEffect(() => {
    axios.get(`${API}/super/labs/${labId}/revenue`, { ...h(), params: { period } })
      .then(r => setData(r.data))
      .catch(() => {});
  }, [labId, period]);

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['today', 'week', 'month'].map(p => (
          <button key={p} onClick={() => setPeriod(p)} style={{
            padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700,
            background: period === p ? 'rgba(245,158,11,0.2)' : 'var(--bg2)',
            border: `1px solid ${period === p ? '#f59e0b' : 'var(--border)'}`,
            color: period === p ? '#f59e0b' : 'var(--text2)',
          }}>{p === 'today' ? 'Bugun' : p === 'week' ? 'Hafta' : 'Oy'}</button>
        ))}
      </div>
      {data ? (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div style={{ background: 'var(--bg2)', borderRadius: 12, padding: 20, border: '1px solid var(--border)' }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 16 }}>To'lov turlari</div>
            {data.by_provider?.map(p => (
              <div key={p.provider} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                <span style={{ fontSize: 13, color: 'var(--text2)' }}>{p.provider}</span>
                <span style={{ fontWeight: 700 }}>{fmt(p.total)} so'm</span>
              </div>
            ))}
            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 10, marginTop: 10, display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontWeight: 700 }}>Jami</span>
              <span style={{ fontWeight: 900, color: '#f59e0b' }}>{fmt(data.total)} so'm</span>
            </div>
          </div>
          <div style={{ background: 'var(--bg2)', borderRadius: 12, padding: 20, border: '1px solid var(--border)' }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 16 }}>Snack daromad</div>
            <div style={{ fontSize: 28, fontWeight: 900, color: '#10b981' }}>{fmt(data.snack_revenue)} so'm</div>
          </div>
        </div>
      ) : <div style={{ color: 'var(--text3)' }}>Yuklanmoqda...</div>}
    </div>
  );
}

// ── Tab: Snack ───────────────────────────────────────────────────────────────
function SnackTab({ labId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/super/labs/${labId}/snacks`, h()).then(r => setData(r.data)).catch(() => {});
  }, [labId]);

  return (
    <div>
      {data ? (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div style={{ background: 'var(--bg2)', borderRadius: 12, padding: 20, border: '1px solid var(--border)' }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 16 }}>Mahsulotlar</div>
            {data.products?.map(p => (
              <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                <span style={{ fontSize: 13 }}>{p.name}</span>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>{p.sold_count} ta</div>
                  <div style={{ fontSize: 11, color: '#10b981' }}>{fmt(p.sold_revenue)} so'm</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ background: 'var(--bg2)', borderRadius: 12, padding: 20, border: '1px solid var(--border)' }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 16 }}>So'nggi buyurtmalar</div>
            {data.recent_orders?.map(o => (
              <div key={o.id} style={{ marginBottom: 10, fontSize: 12 }}>
                <div>{o.product_name} × {o.quantity}</div>
                <div style={{ color: 'var(--text3)' }}>{new Date(o.created_at).toLocaleString('uz-UZ')}</div>
              </div>
            ))}
          </div>
        </div>
      ) : <div style={{ color: 'var(--text3)' }}>Yuklanmoqda...</div>}
    </div>
  );
}

// ── Tab: Sozlamalar ──────────────────────────────────────────────────────────
function SettingsTab({ lab, labId, onReload }) {
  const [toggling, setToggling] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [newPass, setNewPass] = useState('');
  const [msg, setMsg] = useState('');

  const toggle = async () => {
    if (!window.confirm(`Klubni ${lab.is_active ? 'o\'chirish' : 'yoqish'}ni tasdiqlaysizmi?`)) return;
    setToggling(true);
    try {
      await axios.patch(`${API}/super/labs/${labId}/toggle`, {}, h());
      setMsg('Muvaffaqiyatli o\'zgartirildi');
      onReload();
    } catch (e) { setMsg(e.response?.data?.error || 'Xatolik'); }
    setToggling(false);
  };

  const resetPass = async () => {
    if (!newPass.trim()) return setMsg('Yangi parol kiriting');
    if (!window.confirm('Parolni almashtirilsinmi?')) return;
    setResetting(true);
    try {
      await axios.post(`${API}/super/labs/${labId}/reset-password`, { new_password: newPass }, h());
      setMsg('Parol almashtirildi. Barcha qurilmalardan chiqarildi.');
      setNewPass('');
    } catch (e) { setMsg(e.response?.data?.error || 'Xatolik'); }
    setResetting(false);
  };

  return (
    <div style={{ maxWidth: 500 }}>
      {msg && <div style={{ padding: '12px 16px', borderRadius: 10, marginBottom: 16, background: 'rgba(16,185,129,0.1)', border: '1px solid #10b981', color: '#10b981' }}>{msg}</div>}

      <div style={{ background: 'var(--bg2)', borderRadius: 12, padding: 20, border: '1px solid var(--border)', marginBottom: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>Klub holati</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 13, color: 'var(--text2)' }}>Hozir: <strong style={{ color: lab.is_active ? '#10b981' : '#ef4444' }}>{lab.is_active ? 'Faol' : 'O\'chirilgan'}</strong></span>
          <button onClick={toggle} disabled={toggling} style={{
            padding: '8px 18px', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 13,
            background: lab.is_active ? 'rgba(239,68,68,0.15)' : 'rgba(16,185,129,0.15)',
            border: `1px solid ${lab.is_active ? '#ef4444' : '#10b981'}`,
            color: lab.is_active ? '#ef4444' : '#10b981',
          }}>{toggling ? '...' : lab.is_active ? '🔴 O\'chirish' : '🟢 Yoqish'}</button>
        </div>
      </div>

      <div style={{ background: 'var(--bg2)', borderRadius: 12, padding: 20, border: '1px solid var(--border)' }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>Parolni almashtirish</div>
        <input
          value={newPass} onChange={e => setNewPass(e.target.value)}
          placeholder="Yangi parol (min 8 belgi)"
          type="password"
          style={{ width: '100%', padding: '10px 14px', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text)', fontSize: 13, marginBottom: 12, boxSizing: 'border-box' }}
        />
        <button onClick={resetPass} disabled={resetting} style={{
          width: '100%', padding: '10px', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 13,
          background: 'rgba(239,68,68,0.15)', border: '1px solid #ef4444', color: '#ef4444',
        }}>{resetting ? '...' : '🔑 Parolni almashtir'}</button>
      </div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────────────────
export default function SuperLabDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { enter: enterImpersonate } = useImpersonate();
  const [tab, setTab] = useState(0);
  const [lab, setLab] = useState(null);
  const [loading, setLoading] = useState(true);
  const [impLoading, setImpLoading] = useState(false);

  const loadLab = useCallback(() => {
    axios.get(`${API}/super/labs/${id}`, h())
      .then(r => setLab(r.data.lab || r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => { loadLab(); }, [loadLab]);

  if (loading) return <div style={{ color: 'var(--text3)', padding: 40 }}>Yuklanmoqda...</div>;
  if (!lab) return <div style={{ color: 'var(--red)', padding: 40 }}>Klub topilmadi</div>;

  return (
    <div style={{ maxWidth: 1100 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => navigate('/super/labs')} style={{
            background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)',
            padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 13,
          }}>← Orqaga</button>
          <div>
            <div style={{ fontSize: 20, fontWeight: 900 }}>{lab.name}</div>
            <div style={{ fontSize: 12, color: 'var(--text3)' }}>{lab.owner_email}</div>
          </div>
        </div>
        <button
          disabled={impLoading}
          onClick={async () => {
            setImpLoading(true);
            try { await enterImpersonate(id); } catch { setImpLoading(false); }
          }}
          style={{
            padding: '10px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 13,
            background: 'rgba(245,158,11,0.15)', border: '1px solid #f59e0b', color: '#f59e0b',
            display: 'flex', alignItems: 'center', gap: 8,
          }}
        >
          {impLoading ? '...' : '👁️ Panelni ko\'rish'}
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 24, borderBottom: '1px solid var(--border)', paddingBottom: 0 }}>
        {TABS.map((t, i) => (
          <button key={t} onClick={() => setTab(i)} style={{
            padding: '10px 18px', borderRadius: '10px 10px 0 0', cursor: 'pointer', fontWeight: 700, fontSize: 13,
            background: tab === i ? 'rgba(245,158,11,0.12)' : 'transparent',
            border: `1px solid ${tab === i ? '#f59e0b' : 'transparent'}`,
            borderBottom: tab === i ? '1px solid var(--bg)' : 'none',
            color: tab === i ? '#f59e0b' : 'var(--text3)',
            marginBottom: -1,
          }}>{t}</button>
        ))}
      </div>

      <div style={{ paddingTop: 8 }}>
        {tab === 0 && <OverviewTab lab={lab} />}
        {tab === 1 && <ComputersTab labId={id} />}
        {tab === 2 && <SessionsTab labId={id} />}
        {tab === 3 && <RevenueTab labId={id} />}
        {tab === 4 && <SnackTab labId={id} />}
        {tab === 5 && <SettingsTab lab={lab} labId={id} onReload={loadLab} />}
      </div>
    </div>
  );
}
